var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandCloseNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 20L6.97143 13.6667M6.97143 13.6667H1.20879M6.97143 13.6667V19.4722M20 20L13.4857 13.6667M13.4857 13.6667H19.2484M13.4857 13.6667V19.4722M1 1L6.97143 7.33333M6.97143 7.33333H1.20879M6.97143 7.33333V1.73077M20 1L13.4857 7.33333M13.4857 7.33333H19.2484M13.4857 7.33333V1.73077",
    stroke: "#3C2464",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCloseNavigation);
export default __webpack_public_path__ + "static/media/expand_close_navigation.4969166c8ce13ccb1cb6f71d500c1199.svg";
export { ForwardRef as ReactComponent };